import { Component } from '@angular/core';
import { DataService } from './../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
//consultas
import { CookieService } from 'ngx-cookie-service';
import { environment } from './../../../../environments/environment';
import { Apollo } from 'apollo-angular';
import { firstValueFrom, Subscription } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
//servicios
import { getCuestionarioPorId, getCuestionarios, getCuestionariosInfo } from './../../../services/Administrador/cuestionarios/query';
import { getQuestions } from './../../../services/Administrador/questions/query_question';
import { getAnswers } from './../../../services/Administrador/answers/query_answer';
import { cuestionarios, CuestionariosService } from './../../../services/Administrador/cuestionarios/cuestionarios.service';
import { EstructuraService } from './../../../services/Administrador/estructura/estructura.service';
import { QuestionsService } from './../../../services/Administrador/questions/questions.service';
import { AnswersService } from './../../../services/Administrador/answers/answers.service';
import Swal from 'sweetalert2';
import { messages } from '../../funciones/mensajes';

@Component({
  selector: 'app-estructuracion',
  templateUrl: './estructuracion.component.html',
  styleUrl: './estructuracion.component.css'
})
export class EstructuracionComponent {
/* Consultas */
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  public cuestionarios = [];
  public cuestionarioSeleccionado = undefined;

  public cuesSelec = 0;
  public elementParent;

  public addCategory1 = false;
  public editCategory1 = false;
  public addCategory2 = false;
  public editCategory2 = false;

  public addQuestion1 = false;

  public editCategory = undefined;
  public step1 = undefined;
  public step2 = undefined;

  public questions = [];
  public answers = [];
  
  constructor(
    private apollo: Apollo,
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private cuestionarioService: CuestionariosService,
    private questionsService: QuestionsService,
    private estructuraService: EstructuraService,
    private answersService: AnswersService
  ) {
  }
  ngOnInit(){
    this.ListQuestionnaires();
  }
  
  public async seleccionCuestionario(){
    const id = Number(document.getElementById('cuestionario')['value']);
    this.cuesSelec = id;
    this.cuestionarioSeleccionado = undefined;
    try{
      const res = await firstValueFrom(
            this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
              query: getCuestionarioPorId,
              context: { headers: this.headers, },
              fetchPolicy: 'no-cache',
              variables: {
                args: {
                  relations: {
                    loadRelations: "FULL"
                  },
                  filter: {
                    operator: "AND",
                    conditions: [
                      {
                        field: "id",
                        operator: "EQUAL",
                        value: ""+id
                      }
                    ]
                  },
                },
              }
            }).valueChanges.source
          );
      this.cuestionarioSeleccionado = {
        id: res.data.questionnaires[0].id,
        name: res.data.questionnaires[0].name,
        elementos: this.ListelementosCategories(res.data.questionnaires[0].categories, null)
      }
    }catch(err){
      messages.errorMessageGraph(err);
    }
    // this.cuestionarioSeleccionado = this.cuestionarios.find(e => e.id === ''+id);
  }
  /* Consultas */
  public async ListQuestionnaires(){
    try{
      const res = await firstValueFrom(
        this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getCuestionariosInfo,
          context: { headers: this.headers, },
          variables: {
            args: {
              relations: {
                loadRelations: "FULL"
              },
              filter: {
                operator: "AND",
                conditions: [
                  {
                    field: "status",
                    operator: "EQUAL",
                    value: "draft"
                  }
                ]
              },
            },
          }
        }).valueChanges.source 
      );
      this.cuestionarios = [];
      
      if (res.data.questionnaires && Array.isArray(res.data.questionnaires)) {
        res.data.questionnaires.forEach((cuestionario) => {
            this.cuestionarios.push({
              id: cuestionario.id,
              name: cuestionario.name,
              status: cuestionario.status,
            });
        });
      }
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /* obtención elementos */
  public ListelementosCategories(elements, id){
    var elementos = [];
    var cat;
    if(id === null){
      cat = elements.filter( e => e.parent === id);
    }else{
      cat = elements.filter( e => e.parent !== null && e.parent.id === id);
    }

    cat.sort(function(a,b){
      if ( Number(a.id) > Number(b.id) ) {
        return 1;
      }
      if ( Number(a.id) < Number(b.id) ) {
        return -1;
      }
      return 0;
    });

    for(const e of cat){
      const preguntas = this.questions.filter(c => c.categoryId == e.id);
      preguntas.sort(function(a,b){
        if ( Number(a.order) > Number(b.order) ) {
          return 1;
        }
        if ( Number(a.order) < Number(b.order) ) {
          return -1;
        }
        return 0;
      });
      elementos.push({
        id: e.id,
        name: e.name,
        description: e.description,
        parent: e.parent,
        elementos: this.ListelementosCategories(elements, e.id),
        questions: this.structureQuestions(e.questions),
      });
    }
    return elementos;
  }
  public structureQuestions(questions){
    var newQuestions = [];

    for(const q of questions){
      var res = [];
      for(const r of q.answers_options){
        res.push({
          id: r.id,
          respuesta: r.description,
          score: r.score,
        });
      }
      newQuestions.push({
        id: q.id,
        descripcion: q.description,
        order: q.order,
        requerida: q.required,
        respuestas: res
      });
    }

    return newQuestions;
  }
  /* Elements */
  //Apertura de eventos
  public addElement(elementParent,el){
    this.elementParent = elementParent;
    if(el === 1 && elementParent === undefined){
      this.addCategory1 = true;
      this.step1 = undefined;
      this.step2 = undefined;
    }else if(el === 2 && elementParent !== undefined){
      this.addCategory2 = true;
      this.step2 = undefined;
    }
  }
  public editElement(elementParent,el,element){
    this.elementParent = elementParent;
    this.editCategory = element;
    if(el === 1 && elementParent === undefined){
      this.editCategory1 = true;
    }else if(el === 2 && elementParent !== undefined){
      this.editCategory2 = true;
    }
  }
  public cancelElement(){
    this.elementParent = undefined;
    this.addCategory1 = false;
    this.editCategory1 = false;
    this.addCategory2 = false;
    this.editCategory2 = false;
  }
  //Guardado de información
  public async saveElement(element){
    var cate = {
      questionaryId: this.cuesSelec,
      name: element[0],
      description: element[1], 
      parentCategoryId: this.elementParent===undefined?undefined:Number(this.elementParent.id)
    };
    try {
      const data = await firstValueFrom(this.estructuraService.postCategoria(cate));
      var nuevoelemento = {
        description: data['data'].description,
        id: data['data'].id,
        name: data['data'].name,
        parent: data['data'].id,
        questions: [],
        elementos: []
      };
      if(this.elementParent === undefined){
        this.cuestionarioSeleccionado.elementos.push(nuevoelemento)
      }else{
        const el = this.cuestionarioSeleccionado.elementos.find(c => c.id === this.elementParent.id);
        el.elementos.push(nuevoelemento);
      }
      messages.succesMessageGraph(this.translate.instant('admin.cuestionarios.succesN'));
    } catch (error) {
      messages.errorMessageGraph(error.error.message);
    }
    this.cancelElement();
  }
  public async saveEditElement(element: any[]){
    this.editCategory.name = element[0];
    this.editCategory.description = element[1];

    try {
      await firstValueFrom(this.estructuraService.updateCategoria(this.editCategory));
      messages.succesMessageGraph(this.translate.instant('admin.estructura.succesE'));
    } catch (err: any) {
      messages.errorMessageGraph(err.error.message);
    }

    this.cancelElement();

  }
  public async deleteElement(com :any){
    //await Swal.fire ya devuelve uan promesa
    //ya no es necesario el then() para manejar la respuesta

    const result = await messages.confirmationSave(
      this.translate.instant('admin.estructura.deseaEliminarC'),
      this.translate.instant('acciones.continuar'),
      this.translate
    );

    if(result){
      var aux = [];
      if(com.parent !== undefined && com.parent !== null){
        var elem = this.cuestionarioSeleccionado.elementos.find(c => c.id === com.parent.id);
        for(const p of elem.elementos){
          if(p.id !== com.id){
            aux.push(p);
          }
        }
        elem.elementos = aux;
      }else{
        for(const p of this.cuestionarioSeleccionado.elementos){
          if(p.id !== com.id){
            aux.push(p);
          }
        }
        this.cuestionarioSeleccionado.elementos = aux;
      }
      try {
        await firstValueFrom(this.estructuraService.deleteCategoria(com.id));
        messages.succesMessageGraph(this.translate.instant('admin.estructura.succesD'));

      } catch (err: any) {
        messages.errorMessageGraph(err.error.message);
      }
    }
  }
  public async changeStatus(){
    const result = await messages.confirmationSave(
      this.translate.instant('admin.estructura.publicar'),
      this.translate.instant('acciones.continuar'),
      this.translate
    );

    if(result){
      try {
        await firstValueFrom(this.cuestionarioService.statusCuestionario(this.cuesSelec+'', 'closed'));
          this.cuesSelec = undefined;
          this.cuestionarioSeleccionado = undefined;
          messages.succesMessageGraph(this.translate.instant('admin.estructura.succesE'))

          setTimeout(()=>{
          window.location.reload();
        }, 1500)
      } catch (error: any) {
        messages.errorMessageGraph(error.error.message);
      }

    }
       
  }
}
